export const QUALITY_CONTROL = {
    ESTIMATED_VS_ACTUAL_LESS_THAN_10: 'eva_less_than_10',
    ESTIMATED_VS_ACTUAL_10_TO_20: 'eva_10_to_20',
    ESTIMATED_VS_ACTUAL_21_TO_30: 'eva_21_to_30',
    ESTIMATED_VS_ACTUAL_31_TO_40: 'eva_31_to_40',
    ESTIMATED_VS_ACTUAL_MORE_THAN_40: 'eva_more_than_40',

    TOLERANCE_OK: 'tolerance_ok',
    TOLERANCE_NOT_OK: 'tolerance_not_ok',

    WELDING_QUALITY_GOOD: 'welding_quality_good',
    WELDING_QUALITY_NEUTRAL: 'welding_quality_neutral',
    WELDING_QUALITY_BAD: 'welding_quality_bad',

    APPROVE: 'approve',
    REJECT: 'reject',
};

export const QUALITY_CONTROL_STATUS = {
    APPROVED: 'approved',
    REJECTED: 'rejected',
};



// WEBPACK FOOTER //
// ./src/constants/production.js